import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getSiteManagerList = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `site-managers?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}